<!-- /src/components/common/Card/CardGrid.vue -->
<template>
  <div>
    <div v-if="cards.length > 0" class="card-grid">
      <ul class="card-grid__items">
        <li v-for="(card, index) in cards" :key="index">
          <DownloadCard
            v-if="card.post_type == 'downloadable_file'"
            :post="card" :type="card.post_type"
          />
          <Card v-else :post="card" :type="type" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Card from '@/components/common/Card/Card'
import DownloadCard from '@/components/common/Card/DownloadCard'

export default {
  data() {
    return {
      noCards: false,
    }
  },
  props: {
    cards: {
      type: [Array, Object],
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
  },

  computed: {
    getCards() {
      console.log(this.cards)
      return this.cards
    }
  },
  components: {
    Card,
    DownloadCard,
  },
}
</script>

<style scoped>
.card-grid {
  margin-bottom: 3rem;

  &__items {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));
    grid-gap: var(--itemSpacing);
    margin: 0;
    /* @media (--desktop-large) {
      grid-gap: var(--itemSpacing-lg);
    } */
  }
}

.loader {
  text-align: center;
  margin-top: 4rem;
  margin-bottom: 4rem;
}
</style>
